import isArray from 'lodash/isArray';

import { cast, convertToArray } from 'redpoints-front-common/helpers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_CLEAR_FILTERS,
  ALL_INCIDENTS_FILTERS_FETCH_NON_ENFORCEMENT_REASONS_SUCCESS,
  ALL_INCIDENTS_FILTERS_SET_APPLIED_FILTERS,
  ALL_INCIDENTS_FILTERS_SET_ASSET,
  ALL_INCIDENTS_FILTERS_SET_BOOKMARK,
  ALL_INCIDENTS_FILTERS_SET_CLOSURE_DATE,
  ALL_INCIDENTS_FILTERS_SET_CONFIRMATION_DATE,
  ALL_INCIDENTS_FILTERS_SET_DEINDEXATION,
  ALL_INCIDENTS_FILTERS_SET_DETECTION_DATE,
  ALL_INCIDENTS_FILTERS_SET_DOMAINS,
  ALL_INCIDENTS_FILTERS_SET_ENFORCEMENT_DATE,
  ALL_INCIDENTS_FILTERS_SET_ENFORCEMENT_STATUS,
  ALL_INCIDENTS_FILTERS_SET_ENFORCEMENT_STATUS_GROUP,
  ALL_INCIDENTS_FILTERS_SET_INCIDENT_STATUS,
  ALL_INCIDENTS_FILTERS_SET_INCIDENT_STATUS_GROUP,
  ALL_INCIDENTS_FILTERS_SET_LABEL,
  ALL_INCIDENTS_FILTERS_SET_PRIORITY_ID,
  ALL_INCIDENTS_FILTERS_SET_PROTECTION_TYPE,
  ALL_INCIDENTS_FILTERS_SET_REASON_CODES,
  ALL_INCIDENTS_FILTERS_SET_SEARCH_LINK_URL,
  ALL_INCIDENTS_FILTERS_SET_SEARCH_TERM,
} from '../../../../actions/actionTypes';
import { getAllIncidentsFiltersNonEnforcementReasons } from './nonEnforcementReasons';

const WATCH = 'watch';

const transformQueryParamsInArray = value =>
  value ? (Array.isArray(value) ? value : [value]) : [];

const transformBooleans = value =>
  value
    ? convertToArray(value).map(item =>
        ['true', 'false'].includes(item) ? item === 'true' : item
      )
    : value;

const defaultState = {
  assetId: null,
  closureDateFrom: null,
  closureDateTo: null,
  confirmationDateFrom: null,
  confirmationDateTo: null,
  deindexation: null,
  detectionDateFrom: null,
  detectionDateTo: null,
  domainId: null,
  enforcementDateFrom: null,
  enforcementDateTo: null,
  enforcementStatus: [],
  enforcementStatusGroupId: [],
  incidentStatus: [],
  incidentStatusGroupId: [],
  linkStatusGroup: null,
  linkUrl: null,
  reasonCode: [],
  priorityId: [],
  protectionType: null,
  url: null,
  watch: null,
};

export const castAllIncidentsFilters = filters => {
  const {
    assetId,
    closureDateFrom,
    closureDateTo,
    confirmationDateFrom,
    confirmationDateTo,
    deindexation,
    detectionDateFrom,
    detectionDateTo,
    domainId,
    enforcementDateFrom,
    enforcementDateTo,
    enforcementStatus,
    enforcementStatusGroupId,
    incidentStatus,
    incidentStatusGroupId,
    linkUrl,
    reasonCode,
    priorityId,
    protectionType,
    url,
    watch,
  } = filters;

  return cast({
    assetId: cast.number,
    domainId: cast.number,
    enforcementStatus: cast.array(cast.number),
    enforcementStatusGroupId: cast.array(cast.number),
    incidentStatus: cast.array(cast.number),
    incidentStatusGroupId: cast.array(cast.number),
    url: cast.string,
    watch: cast.bool,
    priorityId: value => cast.array(cast.number)(convertToArray(value), []),
    protectionType: cast.string,
    deindexation: item => item,
    detectionDateFrom: cast.string,
    detectionDateTo: cast.string,
    confirmationDateFrom: cast.string,
    confirmationDateTo: cast.string,
    enforcementDateFrom: cast.string,
    enforcementDateTo: cast.string,
    closureDateFrom: cast.string,
    closureDateTo: cast.string,
    linkUrl: cast.string,
    reasonCode: value => cast.array(cast.string)(convertToArray(value), []),
  })({
    domainId,
    enforcementStatus: transformQueryParamsInArray(enforcementStatus),
    enforcementStatusGroupId: transformQueryParamsInArray(
      enforcementStatusGroupId
    ),
    incidentStatus: transformQueryParamsInArray(incidentStatus),
    incidentStatusGroupId: transformQueryParamsInArray(incidentStatusGroupId),
    watch: watch,
    priorityId,
    protectionType,
    url,
    assetId: isArray(assetId) ? undefined : assetId,
    deindexation: transformBooleans(deindexation),
    detectionDateFrom,
    detectionDateTo,
    confirmationDateFrom,
    confirmationDateTo,
    enforcementDateFrom,
    enforcementDateTo,
    closureDateFrom,
    closureDateTo,
    linkUrl,
    reasonCode,
  });
};

export default function (state = defaultState, action) {
  let stringDates = [];

  switch (action.type) {
    case ALL_INCIDENTS_FILTERS_SET_BOOKMARK:
      return {
        ...state,
        watch: action.payload.value === true || defaultState.watch,
      };

    case ALL_INCIDENTS_FILTERS_SET_ASSET:
      return { ...state, assetId: action.payload.assetId };

    case ALL_INCIDENTS_FILTERS_SET_CLOSURE_DATE: {
      const closureDate = action.payload.closureDate || [];
      stringDates = cast.datesToStrings([closureDate[0], closureDate[1]]);
      return {
        ...state,
        closureDateFrom: stringDates[0],
        closureDateTo: stringDates[1],
      };
    }

    case ALL_INCIDENTS_FILTERS_SET_CONFIRMATION_DATE: {
      const confirmationDate = action.payload.confirmationDate || [];
      stringDates = cast.datesToStrings([
        confirmationDate[0],
        confirmationDate[1],
      ]);
      return {
        ...state,
        confirmationDateFrom: stringDates[0],
        confirmationDateTo: stringDates[1],
      };
    }

    case ALL_INCIDENTS_FILTERS_SET_DEINDEXATION:
      return {
        ...state,
        deindexation: action.payload.deindexation,
      };

    case ALL_INCIDENTS_FILTERS_SET_DETECTION_DATE: {
      const detectionDate = action.payload.detectionDate || [];
      stringDates = cast.datesToStrings([detectionDate[0], detectionDate[1]]);
      return {
        ...state,
        detectionDateFrom: stringDates[0],
        detectionDateTo: stringDates[1],
      };
    }
    case ALL_INCIDENTS_FILTERS_SET_DOMAINS:
      return { ...state, domainId: action.payload.domainId };

    case ALL_INCIDENTS_FILTERS_SET_ENFORCEMENT_DATE: {
      const enforcementDate = action.payload.enforcementDate || [];
      stringDates = cast.datesToStrings([
        enforcementDate[0],
        enforcementDate[1],
      ]);
      return {
        ...state,
        enforcementDateFrom: stringDates[0],
        enforcementDateTo: stringDates[1],
      };
    }
    case ALL_INCIDENTS_FILTERS_SET_ENFORCEMENT_STATUS: {
      const { enforcementStatus } = action.payload;
      return {
        ...state,
        enforcementStatus: cast.array(cast.number)(
          enforcementStatus,
          defaultState.enforcementStatus
        ),
      };
    }
    case ALL_INCIDENTS_FILTERS_SET_ENFORCEMENT_STATUS_GROUP: {
      const { enforcementStatusGroupId } = action.payload;
      return {
        ...state,
        enforcementStatusGroupId: cast.array(cast.number)(
          enforcementStatusGroupId,
          defaultState.enforcementStatusGroupId
        ),
      };
    }
    case ALL_INCIDENTS_FILTERS_SET_INCIDENT_STATUS: {
      const { incidentStatus } = action.payload;
      return {
        ...state,
        incidentStatus: cast.array(cast.number)(
          incidentStatus,
          defaultState.incidentStatus
        ),
      };
    }
    case ALL_INCIDENTS_FILTERS_SET_INCIDENT_STATUS_GROUP: {
      const { incidentStatusGroupId } = action.payload;
      return {
        ...state,
        incidentStatusGroupId: cast.array(cast.number)(
          incidentStatusGroupId,
          defaultState.incidentStatusGroupId
        ),
      };
    }
    case ALL_INCIDENTS_FILTERS_SET_LABEL:
      return { ...state, label: action.payload.label };

    case ALL_INCIDENTS_FILTERS_FETCH_NON_ENFORCEMENT_REASONS_SUCCESS: {
      const reasons = getAllIncidentsFiltersNonEnforcementReasons(
        action.payload
      );
      const availableCodes = reasons.map(({ code }) => code);
      return {
        ...state,
        reasonCode: state.reasonCode.filter(code =>
          availableCodes.includes(code)
        ),
      };
    }

    case ALL_INCIDENTS_FILTERS_SET_REASON_CODES: {
      const { reasonCode } = action.payload;
      return {
        ...state,
        reasonCode: cast.array(cast.string)(
          reasonCode,
          defaultState.reasonCode
        ),
      };
    }

    case ALL_INCIDENTS_FILTERS_SET_PRIORITY_ID:
      return { ...state, priorityId: action.payload.priorityId };

    case ALL_INCIDENTS_FILTERS_SET_PROTECTION_TYPE:
      return { ...state, protectionType: action.payload.protectionType };

    case ALL_INCIDENTS_FILTERS_SET_SEARCH_TERM:
      return { ...state, url: action.payload.url };

    case ALL_INCIDENTS_FILTERS_SET_SEARCH_LINK_URL:
      return { ...state, linkUrl: action.payload.linkUrl };

    case ALL_INCIDENTS_FILTERS_SET_APPLIED_FILTERS: {
      const castedObject = castAllIncidentsFilters(action.payload.filters);

      return {
        ...state,
        ...castedObject,
      };
    }

    case ALL_INCIDENTS_CLEAR:
    case ALL_INCIDENTS_FILTERS_CLEAR_FILTERS:
      return defaultState;

    default:
      return state;
  }
}

export const getAllIncidentsFiltersLabelSelected = state =>
  state.watch ? [WATCH] : [];
